import DOMPurify from 'dompurify'

const SCHEME = /^[a-z][a-z0-9+.-]*:/i
const WEB_SCHEME = /^https?:/i

const leavesThePage = href => {
  if (!href || href.startsWith('#')) return false
  return SCHEME.test(href) ? WEB_SCHEME.test(href) : true
}

const withProtocol = href => (SCHEME.test(href) || href.startsWith('/') ? href : `https://${href}`)

export const sanitizeRichText = html => {
  if (!html) return ''

  const body = DOMPurify.sanitize(html, { RETURN_DOM: true })
  const links = body.querySelectorAll('a[href]')

  ;[...links].forEach(link => {
    const href = link.getAttribute('href').trim()
    if (!leavesThePage(href)) return

    link.setAttribute('href', withProtocol(href))
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
  })

  return body.innerHTML
}
